import React from "react";
import { motion } from "framer-motion";

/**
 * Scroll-triggered fade + rise. Wrap any block with this.
 */
export default function Reveal({
  children,
  delay = 0,
  y = 30,
  duration = 0.9,
  className = "",
  once = true,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration, ease: [0.16, 1, 0.3, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
